import { Grid } from "@mui/material";
import Sidebar from "../sidebar/sidebar";
import Headar from "../headar/headar";
import Job from "../Job/job";
const Job_layout = ({props,setIsLoaded}) => {
    return (
        <>
            <Grid container>
                <Grid item md={2.3}>
                    <Sidebar />
                </Grid>
                <Grid item md={9.7}>
                    <Headar />
                    <Job props={props} setIsLoaded={setIsLoaded} />
                </Grid>
            </Grid>
        </>
    )
}
export default Job_layout;